import React, { useEffect, useRef, useState } from "react";
import defaultImg from "../../assets/svg/Vector.png";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import "flatpickr/dist/themes/material_blue.css";
import { Form } from "react-bootstrap";
import "../../components/Rewards/Rewards.css";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router";
import { useSelector } from "react-redux";

export default function AddNewOffer() {
  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  const { id } = useParams();

  const navigate = useNavigate();

  const formatDateLocal = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [dateRange, setDateRange] = useState([]);

  const [offerTypes, setOfferTypes] = useState([]);

  const [discountTypes, setDiscountTypes] = useState([]);

  const [categories, setCategories] = useState([]);

  const [imagePreview, setImagePreview] = useState(null);

  const [offerData, setOfferData] = useState(null);

  const fileInputRef = useRef(null);

  const [formDataState, setFormDataState] = useState({
    is_discounted: false,
    name: "",
    description: "",
    offer_type: "",
    discount_type: "",
    discount_value: "",
    min_order_amount: "",
    usage_limit: "",
    usage_limit_per_user: "",
    code: "",
    is_active: "",
    start_date: "",
    end_date: "",
    background_color: "",
    text_color: "",
    category_ids: [],
    // audience: "",
    images: [],
  });

  const getOfferData = async () => {
    try {
      let response = await axios.get(`${newBaseUrl}/api/portal/offers/${id}`, {
        headers,
      });
      console.log(response.data.data.offer);
      setOfferData(response.data.data.offer);
    } catch (error) {
      console.log(error);
    }
  };

  const getOfferTypes = async () => {
    try {
      let response = await axios.get(`${newBaseUrl}/api/portal/offer-types`, {
        headers,
      });
      console.log(response.data.data);
      setOfferTypes(response.data.data.offer_types);
    } catch (error) {
      console.log(error);
    }
  };

  const getDiscountTypes = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/discount-types`,
        { headers }
      );
      console.log(response);
      setDiscountTypes(response.data.data.discount_types);
    } catch (error) {
      console.log(error);
    }
  };

  const getCategories = async () => {
    try {
      let response = await axios.get(`${newBaseUrl}/api/service_categories`, {
        headers,
      });
      console.log(response.data.data.categories);
      setCategories(response.data.data.categories);
    } catch (error) {
      console.log(error);
    }
  };

  const categoryOptions =
    categories?.map((cat) => ({
      value: String(cat.id),
      label: cat.name,
    })) || [];

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    if (id === "offer_type") {
      const selectedType = offerTypes.find((type) => type.value === value);
      setFormDataState((prev) => ({
        ...prev,
        offer_type: selectedType?.value || "",
        is_discounted: selectedType?.is_discounted || false, // store for conditional render
      }));
    } else if (id === "status") {
      let newValue = "";
      if (value === "active") newValue = 1;
      else if (value === "inactive") newValue = 0;
      else newValue = "";
      setFormDataState((prev) => ({
        ...prev,
        is_active: newValue,
      }));
    } else {
      setFormDataState((prev) => ({
        ...prev,
        [id]: value,
      }));
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size <= 2 * 1024 * 1024) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      setFormDataState((prev) => ({
        ...prev,
        images: [...prev.images, file],
      }));
      reader.readAsDataURL(file);
    } else {
      alert("File is too large. Max size is 2MB.");
    }
  };

  const handleSubmit = async () => {
    const formData = new FormData();

    if (id) {
      formData.append("_method", "PUT");
    }

    formData.append("name", formDataState.name);
    formData.append("description", formDataState.description);
    formData.append("offer_type", formDataState.offer_type);
    formData.append("discount_type", formDataState.discount_type || "");
    formData.append("discount_value", formDataState.discount_value || "");
    formData.append("min_order_amount", formDataState.min_order_amount || "");
    formData.append("background_color", formDataState.background_color || "");
    formData.append("text_color", formDataState.text_color || "");
    formData.append("usage_limit", formDataState.usage_limit || "");
    formData.append(
      "usage_limit_per_user",
      formDataState.usage_limit_per_user || ""
    );
    formData.append("code", formDataState.code);
    formData.append("is_active", formDataState.is_active);

    formData.append("start_date", formatDateLocal(dateRange[0]));
    formData.append("end_date", formatDateLocal(dateRange[1]));

    if (formDataState.images.length > 0) {
      formDataState.images.forEach((img, index) => {
        formData.append(`images[${index}][file]`, img);
      });
    }

    formDataState.category_ids.forEach((catId) => {
      formData.append("category_ids[]", catId);
    });

    const url = id
      ? `${newBaseUrl}/api/portal/offers/${id}`
      : `${newBaseUrl}/api/portal/offers`;

    try {
      const response = await axios.post(url, formData, { headers });
      console.log(response);
      toast.success(response.data.data.message, { autoClose: 3000 });
      navigate("/offers");
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message, { autoClose: 3000 });
    }
  };

  useEffect(() => {
    getCategories();
    getOfferTypes();
    getDiscountTypes();
    if (id) {
      getOfferData();
    }
  }, [id]);

  useEffect(() => {
    if (offerData) {
      setFormDataState({
        is_discounted:
          offerData.pricing?.discount?.type === null ? false : true,
        name: offerData.name,
        description: offerData.description,
        offer_type: offerData.offer_type,
        discount_type: offerData.pricing?.offer_discount?.type,
        discount_value: offerData.pricing?.offer_discount?.value,
        min_order_amount: offerData.pricing?.min_order_amount,
        usage_limit: offerData.usage_limits?.global?.limit,
        usage_limit_per_user: offerData.usage_limits?.per_user?.limit,
        code: offerData.code,
        is_active: offerData.is_active ? 1 : 0,
        start_date: offerData.validity?.dates?.start,
        end_date: offerData.validity?.dates?.end,
        category_ids: offerData.categories?.map((cat) => String(cat.id)) || [],
        background_color: offerData.colors?.background_color,
        text_color: offerData.colors?.text_color,
        images: [],
      });

      if (offerData.images_data?.length > 0) {
        setImagePreview(offerData.images_data[0].url);
      }

      const start = offerData.validity?.dates?.start
        ? new Date(offerData.validity.dates.start)
        : null;
      const end = offerData.validity?.dates?.end
        ? new Date(offerData.validity.dates.end)
        : null;

      if (start && end) {
        setDateRange([start, end]);
      }
    }
  }, [offerData]);

  return (
    <>
      <div className="m-4">
        <div className="reward-header d-flex justify-content-between align-items-center">
          <p className="fs-5 fw-bold my-0">Add New Offer</p>
          <div className="me-1">
            <button className="btn btn-danger opacity-75 py-2">
              Inactive Offer
            </button>
          </div>
        </div>
        <div className="border border-1 rounded-2 my-4">
          <div className="row p-3">
            {/* Image Upload */}
            <p className="mt-0 mb-1">Offer Image</p>
            <div className="reward-image-container my-2 p-3">
              <div className="d-flex justify-content-start align-items-center w-50">
                <div
                  className="reward-image rounded-3 bg-light p-4 my-1 d-flex justify-content-center align-items-center cursor"
                  onClick={handleClick}
                >
                  <img
                    src={imagePreview || defaultImg}
                    className="object-fit-cover rounded-3"
                    style={{ width: "100px", height: "100px" }}
                    alt="Upload preview"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = defaultImg;
                    }}
                  />
                </div>
                <p className="mx-3 my-0 fw-semibold">
                  Upload an image. Max size 2MB
                </p>
              </div>
              <button className="btn border border-1" onClick={handleClick}>
                Browse
              </button>
              <input
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                ref={fileInputRef}
                onChange={handleFileChange}
              />
            </div>
            {/* name  */}
            <div className="reward-name my-2">
              <label htmlFor="name" className="form-label">
                Offer Name
              </label>
              <input
                className="form-control"
                id="name"
                value={formDataState.name}
                onChange={handleInputChange}
                placeholder="Enter Offer Name"
              />
            </div>
            {/* description  */}
            <div className="reward-description my-2">
              <label htmlFor="description" className="form-label">
                Description
              </label>
              <textarea
                className="form-control"
                id="description"
                value={formDataState.description}
                onChange={handleInputChange}
                placeholder="Enter Offer Description"
                rows={5}
              />
            </div>
            {/* offer type & min order  */}
            <div className="reward-section d-flex">
              {/* offer type  */}
              <div className="my-2 reward-type w-50 me-3">
                <label htmlFor="offer_type" className="form-label">
                  Offer Type
                </label>
                <select
                  className="form-select"
                  id="offer_type"
                  value={formDataState.offer_type}
                  onChange={handleInputChange}
                >
                  <option value="">Select Type</option>
                  {offerTypes?.map((type) => (
                    <option value={type.value}>{type.label}</option>
                  ))}
                </select>
              </div>
              {/* min order  */}
              <div className="my-2 min-order-value w-50 ms-3">
                <label htmlFor="min_order_amount" className="form-label">
                  Min Order amount (Optional)
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="min_order_amount"
                  value={formDataState.min_order_amount}
                  onChange={handleInputChange}
                  placeholder="Enter number"
                />
              </div>
            </div>
            {/* Discount Type & value */}
            {formDataState.is_discounted && (
              <div className="reward-section d-flex">
                {/* Discount Type */}
                <div className="my-2 reward-type w-50 me-3">
                  <label htmlFor="discount_type" className="form-label">
                    Discount Type
                  </label>
                  <select
                    className="form-select"
                    id="discount_type"
                    value={formDataState.discount_type}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Type</option>
                    {discountTypes.map((type) => (
                      <option key={type.value} value={type.value}>
                        {type.label}
                      </option>
                    ))}
                  </select>
                </div>
                {/* Discount Value */}
                <div className="my-2 min-order-value w-50 ms-3">
                  <label htmlFor="discount_value" className="form-label">
                    Discount Value
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="discount_value"
                    value={formDataState.discount_value}
                    onChange={handleInputChange}
                    placeholder="Enter value"
                  />
                </div>
              </div>
            )}
            {/* Usage limit */}
            <div className="reward-section d-flex">
              {/* limit  */}
              <div className="my-2 min-order-value w-50 me-3">
                <label htmlFor="usage_limit" className="form-label">
                  Usage limit (Optional)
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="usage_limit"
                  value={formDataState.usage_limit}
                  onChange={handleInputChange}
                  placeholder="Enter limit"
                />
              </div>
              {/* limit per user  */}
              <div className="my-2 min-order-value w-50 ms-3">
                <label htmlFor="usage_limit_per_user" className="form-label">
                  Usage limit per user (Optional)
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="usage_limit_per_user"
                  value={formDataState.usage_limit_per_user}
                  onChange={handleInputChange}
                  placeholder="Enter limit"
                />
              </div>
            </div>
            {/* code & dates */}
            <div className="reward-section d-flex">
              {/* code  */}
              <div className="reward-name my-2 w-50 me-3">
                <label htmlFor="code" className="form-label">
                  Code
                </label>
                <input
                  className="form-control"
                  id="code"
                  value={formDataState.code}
                  onChange={handleInputChange}
                  placeholder="Enter Code"
                />
              </div>
              {/* dates  */}
              <div className="my-2 reward-date w-50 ms-3">
                <Form.Group>
                  <Form.Label htmlFor="date">Validity Dates</Form.Label>
                  <Flatpickr
                    id="date"
                    className="form-control"
                    placeholder="Select Dates"
                    options={{
                      mode: "range",
                      dateFormat: "Y-m-d",
                      showMonths: 2,
                    }}
                    value={dateRange}
                    onClose={(selectedDates) => {
                      if (selectedDates.length === 2) {
                        setDateRange(selectedDates);
                      }
                    }}
                  />
                </Form.Group>
              </div>
            </div>
            {/* status & categories */}
            <div className="reward-section d-flex">
              {/* status  */}
              <div className="my-2 reward-type w-50 me-3">
                <label htmlFor="status" className="form-label">
                  Status
                </label>
                <select
                  id="status"
                  className="form-select"
                  value={
                    formDataState.is_active === ""
                      ? ""
                      : formDataState.is_active === 1
                      ? "active"
                      : "inactive"
                  }
                  onChange={handleInputChange}
                >
                  <option value="">Select Type</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
              {/* categories */}
              <div className="my-2 reward-type w-50 ms-3">
                <label htmlFor="category_ids" className="form-label">
                  Categories
                </label>
                <Select
                  isMulti
                  options={categoryOptions}
                  value={categoryOptions.filter((opt) =>
                    formDataState.category_ids.includes(opt.value)
                  )}
                  onChange={(selectedOptions) => {
                    const selectedIds = selectedOptions.map((opt) => opt.value);
                    setFormDataState((prev) => ({
                      ...prev,
                      category_ids: selectedIds,
                    }));
                  }}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select categories..."
                />
              </div>
              {/* Audience  
              <div className="my-2 reward-type w-50 ms-3">
                <label htmlFor="audience" className="form-label">
                  Audience
                </label>
                <select
                  id="audience"
                  className="form-select"
                  disabled
                  value={formDataState.audience}
                  onChange={handleInputChange}
                >
                  <option value="">Select Audience</option>
                  <option value="all">All Users</option>
                  <option value="vip">VIP</option>
                </select>
              </div> */}
            </div>
            {/* background & text color */}
            <div className="reward-section d-flex">
              {/* background */}
              <div className="reward-background my-2 w-50 me-3">
                <label htmlFor="background_color" className="form-label">
                  Background Color
                </label>
                <input
                  className="form-control"
                  id="background_color"
                  value={formDataState.background_color}
                  onChange={handleInputChange}
                  placeholder="Enter Background Color"
                />
              </div>
              {/* text */}
              <div className="reward-color my-2 w-50 ms-3">
                <label htmlFor="text_color" className="form-label">
                  Text Color
                </label>
                <input
                  className="form-control"
                  id="text_color"
                  value={formDataState.text_color}
                  onChange={handleInputChange}
                  placeholder="Enter Text Color"
                />
              </div>
            </div>
          </div>
          {/* Footer */}
          <div className="reward-footer w-25 mx-auto d-flex justify-content-center align-items-center my-3">
            <button
              className="btn border border-1 px-5 me-3"
              onClick={() => navigate("/offers")}
            >
              Cancel
            </button>
            <button className="btn btn-dark px-5 me-3" onClick={handleSubmit}>
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
